import { config } from "src/config";

interface IResponseLoginUser {
  status: string;
  error: null | string;
}

interface ResponseRegUser {
  status: string;
  data: {
    id: string,
    p2pKey: string,
    stakingKey: string
  };
  error: string | null;
}

interface CheckCredentials {
  status: boolean,
  error: string
}

interface IsUserExists {
  status: string,
  data: {
    userExistsByEmail: boolean,
    userExistsByTelegramId: boolean
  },
  error: string | null
}

class AuthService {
  async fetchLoginUser(userEmail: string, userPassword: string): Promise<IResponseLoginUser> {
    try {
      const url = `${config.bazerAPI}/auth/login`;

      const requestOptions: RequestInit = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: userEmail, password: userPassword }),
        credentials: 'include'
      };

      const response = await fetch(url, requestOptions);
      const data = await response.json();

      return data as IResponseLoginUser;
    } catch (error) {
      console.error(`error fetching ligin user: ${error.message}`);

      return {
        status: 'error',
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  }

  async fetchRegisterUser(email: string, password: string, telegramId: number): Promise<ResponseRegUser> {
    const data = JSON.stringify({
      "email": email,
      "password": password,
      "telegramId": telegramId,
      "referId": "bzr92c1frq6ttv"
    });

    const requestOptions: RequestInit = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: data,
      credentials: 'include'
    };
    try {
      const response = await fetch(`${config.bazerAPI}/auth/register`, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log('response', response)


      const result = await response.json();

      return result as ResponseRegUser;
    } catch (error) {
      console.error("Error during registration:", error);

      return {
        status: 'error',
        data: {
          id: '',
          p2pKey: '',
          stakingKey: ''
        },
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  };

  async fetchLogoutUser() {
    try {
      const url = `${config.bazerAPI}/auth/logout`;

      const requestOptions: RequestInit = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
      };

      const response = await fetch(url, requestOptions);
      const data = await response.json();

      console.log(data)

      return data as IResponseLoginUser;
    } catch (error) {
      console.error(`error fetching ligin user: ${error.message}`);

      return {
        status: 'error',
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  };

  async checkCredentials(email: string, password: string): Promise<CheckCredentials> {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        "email": email,
        "password": password
      });

      const requestOptions: RequestInit = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow" as RequestRedirect
      };

      const response = await fetch(`${config.bazerAPI}/auth/checkCredentials`, requestOptions);

      const data = await response.json();

      if (data.status === 'success') {
        return {
          status: true,
          error: ''
        }
      } else {
        return {
          status: false,
          error: 'password is incorrect'
        }
      }
    } catch (error) {
      console.error(`error checking credentials: ${error.message}`);

      return {
        status: false,
        error: 'error check credentials'
      }
    }
  };

  async isUserExists(email: string, telegramId: number): Promise<IsUserExists> {
    try {
      const requestOptions: RequestInit = {
        method: "GET",
        redirect: "follow" as RequestRedirect
      };

      const response = await fetch(`${config.bazerAPI}/auth/isUserExists?email=${email}&telegramId=${telegramId}`, requestOptions);

      const resultApi = await response.json();

      return resultApi as IsUserExists
    } catch (error) {
      console.error(`error checking user exist: ${error.message}`);

      return {
        status: "error",
        data: {
          userExistsByEmail: true,
          userExistsByTelegramId: true
        },
        error: error.message
      }
    }
  }
}

export default new AuthService;